@if (showPrequalifyInfo) {
  <div class="card__info card__info--primary">
    <span class="card__info__title">{{
      'dashboard-payment-block.component.prequalification'
        | localise: 'Prequalification'
    }}</span>
    <span class="card__info__text-info">
      @if (prequalifyStatus === prequalifyStatusEnum.Requested) {
        {{
          'dashboard-payment-block.component.prequalification_in_review'
            | localise
              : 'Tongo is reviewing your prequalification. We’ll send you an email shortly.'
        }}
      }
      @if (prequalifyStatus === prequalifyStatusEnum.Approved) {
        {{
          'dashboard-payment-block.component.prequalification_congrats'
            | localise
              : 'Congratulations on pre-qualifying for Tongo services, please click'
        }}
        <a
          href="javascript:void(0)"
          (click)="addDeal.emit()"
          class="tongo-link">
          {{
            'dashboard-payment-block.component.access_upcoming_commission_link'
              | localise: 'here'
          }}
        </a>
        {{
          'dashboard-payment-block.component.access_upcoming_commission'
            | localise: 'to access your upcoming commission.'
        }}
      }
      @if (prequalifyStatus === prequalifyStatusEnum.Rejected) {
        {{
          'dashboard-payment-block.component.prequalification_not_passed'
            | localise
              : 'You have not passed pre-qualifying, for all questions, please contact'
        }}
        <a href="mailto:support@gettongo.com" class="tongo-link">
          {{
            'dashboard-payment-block.component.support_email_link'
              | localise: 'support@gettongo.com'
          }}
        </a>
      }
    </span>
  </div>
} @else {
  @if (!hidePaymentWidget) {
    <div class="card__info card__info--primary">
      @if (nextPromisedPayment) {
        <ng-container
          *ngTemplateOutlet="
            dueAsOfToday;
            context: {
              title:
                nextPromisedPayment?.status ===
                promisedPaymentStatusEnum.Processing
                  ? ('dashboard-payment-block.component.promised_payment_status_payment_processing'
                    | localise: 'Payment Processing')
                  : '',
            }
          "></ng-container>
        <!--Your payment of is scheduled-->
        @if (
          nextPromisedPayment?.status === promisedPaymentStatusEnum.Scheduled
        ) {
          <span class="payment-is-due__subinfo">
            {{
              'dashboard-payment-block.component.your_payment_of'
                | localise: 'Your payment of'
            }}
            {{ nextPromisedPayment.total | currencyJs: { showSymbol: true } }}
            {{
              'dashboard-payment-block.component.your_payment_scheduled'
                | localise: ' is scheduled '
            }}
            {{ nextPromisedPayment.effectiveDate | dateApp }}
          </span>
        }
        @if (
          nextPromisedPayment?.status === promisedPaymentStatusEnum.Processing
        ) {
          <span class="payment-is-due__subinfo">
            {{
              'dashboard-payment-block.component.your_payment_of_processing'
                | localise: 'Your payment of'
            }}
            {{ nextPromisedPayment.total | currencyJs: { showSymbol: true } }}
            {{
              'dashboard-payment-block.component.your_payment_processed'
                | localise: ' is currently being processed.'
            }}
          </span>
        }
      }
      <!--isNextDraftDeal && !isWithdrawWithoutCredit-->
      @if (isNextDraftDeal && !isWithdrawWithoutCredit) {
        <span class="card__info__title">{{
          'dashboard-payment-block.component.payments_title'
            | localise: 'Payments'
        }}</span>
        <span class="card__info__text-info">
          {{
            'dashboard-payment-block.component.next_draft_deal_reviewing'
              | localise: 'Congratulations on your deal, we are reviewing'
          }}
        </span>
      }
      <!--isWithdrawWithoutCredit-->
      @if (isWithdrawWithoutCredit) {
        <div class="card__info__zero-state">
          <img src="../../../../../assets/img/icons/dollar-flow.svg" />
          <div>
            {{
              'dashboard-payment-block.component.your_commission_advance_is_ready'
                | localise
                  : 'Your commission advance is ready! Don’t have your Tongo card yet? Set up a transfer instead.'
            }}
          </div>
        </div>
      }
      <!--isScheduledPaymentWasDue-->
      @if (isScheduledPaymentWasDue) {
        <span class="card__info__title">{{
          'dashboard-payment-block.component.scheduled_payment_due_title'
            | localise: 'Payments'
        }}</span>
        <span class="card__info__text-info">
          <p class="scheduled-payment-was-due">
            {{
              'dashboard-payment-block.component.scheduled_payment_for'
                | localise: 'Payment is scheduled for'
            }}
            {{ prevPromisedPayment?.effectiveDate | dateApp }}
            {{
              'dashboard-payment-block.component.scheduled_payment_for_2'
                | localise: ', if anything changes please reach out to'
            }}
            <a href="mailto:support@gettongo.com" class="tongo-link">
              {{
                'dashboard-payment-block.component.support_email_link'
                  | localise: 'support@gettongo.com'
              }} </a
            >. <br />{{
              'dashboard-payment-block.component.thank_you_text'
                | localise: 'Thank you!'
            }}
          </p>
        </span>
      }
      <!--isNextPaymentIsDue || isPaymentPastDue-->
      @if (isNextPaymentIsDue || isPaymentPastDue) {
        <ng-container *ngTemplateOutlet="dueAsOfToday"></ng-container>
        <!--Payment Due (Grace Period)-->
        @if (isGracePeriodDeal && paymentDueBalance?.paymentDue) {
          <span class="payment-is-due__subinfo">
            {{ 'cloc.component.payment_due' | localise: 'Payment Due' }}
          </span>
        }
        <!--Your payment for is past due-->
        @if (
          isPaymentPastDue &&
            !isGracePeriodDeal &&
            paymentDueBalance?.paymentDue;
          as paymentDue
        ) {
          <span class="payment-is-due__subinfo payment-is-due__past_due">
            {{
              'dashboard-payment-block.component.payment_for'
                | localise: 'Your payment for '
            }}
            {{ paymentDue.address }}
            {{
              'dashboard-payment-block.component.payment_past_due_schedule_payment'
                | localise
                  : ' is past due. Please schedule a payment now to avoid your balance being moved to external collections.'
            }}
          </span>
        }
      }
      <div class="card__info__actions">
        @if (isGracePeriodDeal || isPaymentPastDue) {
          <button
            mat-flat-button
            class="action-button action-button--secondary"
            color="secondary"
            (click)="updateClosingDate.emit()">
            {{
              'dashboard-payment-block.component.update_closing_date_button'
                | localise: 'Update Closing Date'
            }}
          </button>
        }
        @if (isWithdrawWithoutCredit) {
          <button
            mat-flat-button
            class="action-button action-button--primary add-deal-button"
            color="secondary"
            (click)="transferMoney.emit()">
            {{
              'dashboard-payment-block.component.transfer_funds'
                | localise: 'Transfer Funds'
            }}
          </button>
        }
        @if (isNextPaymentIsDue) {
          <button
            mat-flat-button
            class="action-button action-button--primary"
            color="primary"
            (click)="schedulePaymentForNextDeal.emit()">
            <span class="material-icons-outlined">payment</span>
            {{
              'dashboard-payment-block.component.schedule_payment_button'
                | localise: 'Schedule Payment'
            }}
          </button>
        }
        @if (
          isNextPaymentIsScheduled &&
          nextPromisedPayment &&
          [
            promisedPaymentStatusEnum.Scheduled,
            promisedPaymentStatusEnum.Processing,
          ].includes(nextPromisedPayment.status)
        ) {
          <button
            mat-flat-button
            class="action-button"
            [disabled]="deleting"
            (click)="editPayment.emit(nextPromisedPayment?.id || 0)">
            <span class="material-icons-outlined">payment</span>
            {{
              'dashboard-payment-block.component.payment_details_button'
                | localise: 'Payment Details'
            }}
          </button>
        }
        @if (
          isScheduledPaymentWasDue &&
          prevPromisedPayment?.status === promisedPaymentStatusEnum.Scheduled
        ) {
          <button
            mat-flat-button
            class="action-button"
            [disabled]="deleting"
            (click)="editPayment.emit(prevPromisedPayment?.id || 0)">
            <span class="material-icons-outlined">payment</span>
            {{
              'dashboard-payment-block.component.view_payment_button'
                | localise: 'View Payment'
            }}
          </button>
        }
        @if (isPaymentPastDue) {
          <button
            mat-flat-button
            class="action-button action-button--primary"
            (click)="schedulePaymentForPastDeal.emit()">
            <span class="material-icons-outlined">payment</span>
            {{
              'dashboard-payment-block.component.schedule_payment_button'
                | localise: 'Schedule Payment'
            }}
          </button>
        }
      </div>
    </div>
  } @else {
    <div class="card__info card__info--primary">
      <span class="payment-block-is-disabled__text">
        {{
          'dashboard-payment-block.component.payment_block_is_disabled_text'
            | localise
              : 'To make a payment, please contact support at (929) 456-5396 or'
        }}
        <a href="mailto:support@gettongo.com" class="tongo-link-black">{{
          'dashboard-payment-block.component.support_email_link'
            | localise: 'support@gettongo.com'
        }}</a
        >.
      </span>
    </div>
  }
}

<ng-template #dueAsOfToday let-title="title">
  <span class="card__info__title">{{
    title ||
      ('dashboard-payment-block.component.due_as_of_today_title'
        | localise: 'Due as of Today')
  }}</span>
  <span class="card__info__subtext">{{
    'dashboard-payment-block.component.total_balance_includes_fees'
      | localise: 'Total balance includes fees.'
  }}</span>
  <span class="card__info__amount">{{
    fullBalanceInfo?.balance | currencyJs: { showSymbol: true }
  }}</span>

  <div class="payment-is-due">
    <div class="payment-is-due__details">
      <div class="payment-is-due__details__item">
        <p>
          {{
            'dashboard-payment-block.component.principal'
              | localise: 'Principal'
          }}
        </p>
        <span>{{
          fullBalanceInfo?.principal | currencyJs: { showSymbol: true }
        }}</span>
      </div>
      <div class="payment-is-due__details__item">
        <p>
          {{
            'dashboard-payment-block.component.fees&Charges'
              | localise: 'Fees & Charges'
          }}
        </p>
        <span>{{
          (fullBalanceInfo
            ? fullBalanceInfo.fees.add(fullBalanceInfo.nsfFee)
            : 0
          ) | currencyJs: { showSymbol: true }
        }}</span>
      </div>
    </div>
  </div>
</ng-template>
